// -------------------------------------------//
//              OnOffSlider
// -------------------------------------------//
angular.module('app.directives.onoffslider', []).directive('kermiOnOffSlider',
    [
        '$document', '$timeout', 'appConfig', '$q', '$translate',
        function ($document, $timeout, appConfig, $q, $translate) {
            var obj = {
                x: 0,
                startX: 0,
                initValue: 0,
                scope: {
                    model: "=model",
                    savebtn: '@',
                    // Slider Withd
                    sliderwidth: '@sliderWidth',
                    // Datapoint
                    config: '=config',
                    // Show Buttons (Savebuttons)
                    withButtons: '=withButtons',
                    // CallBack when saved
                    kCallback: '=kCallback',
                    // CallBack when saved
                    kCallbackParams: '=kCallbackParams',
                    // Hide Info
                    hideInfo: '=hideInfo',
                    // Labels
                    labels: "=labels",
                    // Classes
                    classes: "=classes",
                    // Enables/Disables slider
                    disabled: "=disabled",
                    // Suppress Apply on Write model
                    supressApply : '=supressApply',
                    interact: '=interact'
                },
                restrict: 'AE',
                templateUrl: 'views/form/onoffslider.html',


                // -------------------------------------------//
                //              Calculate Functions
                // -------------------------------------------//
                getPercentFromValue: function (value) {
                    return value == true ? 100 : 0;
                },


                // -------------------------------------------//
                //              Link Function
                // -------------------------------------------//
                link: function (scope, element, attrs, controller) {
                    // -------------------------------------------//
                    //              Init
                    // -------------------------------------------//

                    var offset = function (elm) {
                        try {
                            return elm.offset();
                        } catch (e) {
                        }
                        var rawDom = elm[0];
                        var _x = 0;
                        var _y = 0;
                        var body = document.documentElement || document.body;
                        var scrollX = window.pageXOffset || body.scrollLeft;
                        var scrollY = window.pageYOffset || body.scrollTop;
                        _x = rawDom.getBoundingClientRect().left + scrollX;
                        _y = rawDom.getBoundingClientRect().top + scrollY;
                        return {left: _x, top: _y};
                    };



                    //let startX = offset(element.find('div').eq(0)).left;
                    //let startY = 0;
                    let x = 0;
                    //let y = 0;

                    /* Prepare incoming Data */


                    //var value = 1;
                    var container = element.find('div').eq(0);
                    //  console.log(element.children());
                    var handle = element.find('div').eq(2);
                    var progress = element.find('div').eq(1);
                    var info = element.find('div').eq(6);
                    //var buttons = element.find('div').eq(3);
                    var initValue = 0;
                    var newleft = 0;
                    var byHandle = false;
                    //var saveclear = false;
                    var touchConfig = appConfig();
                    var touchStart = touchConfig.touchStart;
                    var touchMove = touchConfig.touchMove;
                    var touchEnd = touchConfig.touchEnd;
                    var disabled = false;
                    var interact = false;
                    if (!scope.sliderwidth) {
                        scope.sliderwidth = 30;
                    }
                    //scope.interact = false;
                    container.css({
                        position: 'relative',
                        'width': scope.sliderwidth + 'px',
                        'min-width': scope.sliderwidth + 'px'
                    });

                    scope.$watch('config', function (value) {
                        if (!scope.interact && value !== undefined) {
                            // datapoint = value;
                            initSlider(scope.model);
                            //scope.toggleButton(false);
                        }
                    });
                    scope.$watch('labels', function (value) {
                        scope.label = value;
                        scope.setLabels();
                    });

                    // -------------------------------------------//
                    //              Render -> Set CSS
                    // -------------------------------------------//
                    var renderSlider = function (x) {

                        progress.css({
                            width: x + '%'
                        });
                        handle.css({
                            left: x + '%'
                        });
                    };

                    var renderSliderByValue = function (value) {
                        x = (value == true) ? 100 : 0;
                        renderSlider(x);
                    };

                    scope.$watch('model', function (value) {
                        if (!interact && scope.value != scope.model) {
                            // datapoint = value;
                            renderSliderByValue(scope.model);
                            scope.value = scope.model;
                            scope.setLabels();

                            //scope.toggleButton(false);
                        }
                    });
                    scope.$watch('disabled', function (value) {
                        disabled = value;
                    });
                    scope.$watch('interact', function (value) {
                        //console.log('scope: ' + scope.interact + ', local: ' + interact + ', new: ' + value);
                        interact = value;
                    });

                    // -------------------------------------------//
                    //              Set all Vars
                    // -------------------------------------------//
                    function setVars(value) {
                        var min = 0;
                        if (value != undefined) {
                            scope.value = false;
                        } else {
                            scope.value = min;
                            initValue = min;
                        }

                        newleft = obj.getPercentFromValue(scope.value);
                        renderSliderByValue(scope.value);

                    }

                    var renderSliderByMouseLeft = function (mouseLeft) {
                        // IE Fires last event with NAN
                        if (mouseLeft && !disabled) {

                            var percent = ( ( mouseLeft - offset(element.find('div').eq(0)).left ) / scope.sliderwidth ) * 100;
                            if (percent < 0) {
                                percent = 0;
                            } else if (percent > 100) {
                                percent = 100;
                            }



                            scope.value = percent >= 50;

                            renderSlider(percent);
                        }
                    };

                    var mousemove = function (event) {
                        scope.dragging = true;
                        renderSliderByMouseLeft(event.touches[0].clientX);
                        scope.$digest();
                    };

                    function initSlider(value) {
                        if(scope.config){
                            if(scope.config.sliderWidth)
                            {
                                scope.sliderwidth = scope.config.sliderWidth;
                            }
                        }
                        setVars(value);
                        if (newleft < 0) {
                            newleft = 0;
                        }

                        if (newleft > 100) {
                            newleft = 100;
                        }

                        handle.css({
                            'left': newleft + '%'
                        });
                        progress.css({
                            width: newleft + '%'
                        });
                        info.css({
                            width: (scope.sliderwidth + 20 ) + 'px'
                        });
                        if (scope.disabled) {
                            disabled = true;
                        }
                        interact = (scope.interact ? true : false);
                    }

                    var mouseup = function (event) {

                        event.originalEvent.preventDefault();
                        event.originalEvent.stopPropagation();
                        event.originalEvent.stopImmediatePropagation();
                        renderSliderByValue(scope.value);
                        scope.dragging = false;
                        $timeout(function(){
                            interact = false;
                        },500);
                        info.removeClass('show');
                        element.addClass('manual');
                        $document.off(touchMove);
                        $document.off(touchEnd);
                        handle.off(touchEnd);

                        if(scope.valBeforeInteraction === undefined || scope.valBeforeInteraction != scope.value)
                        {


                                scope.writeToModel();
                            //scope.$apply(function () {});
                        }
                        scope.$digest(function () {

                        });


                    };

                    var onOffContainerDown = function (event) {
                        event.originalEvent.preventDefault();
                        event.originalEvent.stopPropagation();
                        scope.valBeforeInteraction = scope.value;
                        interact = true;
                        byHandle = false;


                        $document.on(touchMove, function (e) {
                            touchConfig.touch(e, mousemove);
                        });
                        $document.on(touchEnd, function (e) {
                            touchConfig.touch(e, mouseup);
                        });

                        renderSliderByMouseLeft(touchConfig.touch(event).touches[0].clientX);


                    };
                    element.on(touchStart, function (e) {
                        if (!disabled) {
                            touchConfig.touch(e, onOffContainerDown);
                        }
                    });


                    // -------------------------------------------//
                    //              Handle down
                    // -------------------------------------------//
                    //

                    var onOffHandleDown = function (event) {

                        event.originalEvent.preventDefault();
                        event.originalEvent.stopPropagation();
                        interact = true;
                        scope.valBeforeInteraction = scope.value;
                        element.removeClass('manual');
                        info.addClass('show');

                        byHandle = true;
                        renderSliderByMouseLeft(event.clientX);

                        $document.on(touchMove, function (e) {
                            touchConfig.touch(e, mousemove);
                        });
                        $document.on(touchEnd, function (e) {
                            touchConfig.touch(e, mouseup);
                        });


                    };
                    handle.on(touchStart, function (e) {
                        touchConfig.touch(e, onOffHandleDown);
                    });





                    scope.setLabels = function () {
                        scope.label = {};
                        if (scope.labels === undefined || scope.labels === null) {
                            scope.label.truevalue = $translate.instant('On');
                            scope.label.falsevalue = $translate.instant('Off');
                        } else {

                            scope.label.truevalue = scope.labels.TrueLabel !== undefined ? scope.labels.TrueLabel : scope.labels[true];
                            scope.label.falsevalue = scope.labels.FalseLabel !== undefined ? scope.labels.FalseLabel : scope.labels[false];
                        }
                    };
                    scope.setLabels();














                    scope.writeToModel = function () {

                        if (typeof scope.kCallback == 'function') {
                            var defer = $q.defer();
                            scope.kCallback({
                                promise: defer,
                                params: scope.kCallbackParams,
                                value: scope.value,
                                withButtons: scope.withButtons
                            });
                            // Write to Model if return value == true;
                            defer.promise.then(function(aktVal){
                                // scope.model = scope.value;
                                interact = false;
                                scope.model = aktVal;
                                // We need to render by new model, because scope.model $watch does not fire in fact of scope.interact is true
                                // This is important if we change by Slider and datapoint directive shows buttons for save and clear
                                // While Buttons were shown no new data (e.g. interval) were parsed.
                                scope.value = scope.model;
                                renderSliderByValue(scope.model);

                            },function(){

                            });
                        } else {
                            // Nothing to check;


                            scope.model = scope.value;
                            interact = false;
                            // Careful using this.
                            // Without a callback (Scenes SetDatapoint) we can run into performance issues
                            // But we need this because Parent Object needs dirtyCheck cycle to display current value
                            // Todo: In future use pherhaps implement a scope.supressApply to handle this
                            if(scope.supressApply){ return; }
                            scope.$apply();
                        }

                    };

                    scope.setValue = function (val, e) {
                        e.preventDefault();
                        e.stopPropagation();

                        if (disabled) {
                            return;
                        }

                        // prevent Writing when mouseup fired before
                        if(!interact) {
                            scope.value = val;
                            renderSliderByValue(scope.value);

                            //scope.writeToModel();

                        }

                    };


                    // -------------------------------------------//
                    //              Reset Value
                    // -------------------------------------------//
                    scope.resetValue = function () {
                        scope.value = initValue;
                        renderSliderByValue(initValue);
                    };


                    initSlider(scope.model);
                }

            };
            return obj;


        }]);
